import { useState } from 'react';

export default function FinalCTA() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // メール本文を作成
    const mailBody = `
お名前: ${formData.name}
会社名: ${formData.company}
メールアドレス: ${formData.email}
電話番号: ${formData.phone}
ご希望のサービス: ${formData.service}
お問い合わせ内容: ${formData.message}
    `.trim();

    // メールリンクを作成
    const mailtoLink = `mailto:arise@ishiki24.net?subject=お問い合わせ - ${formData.name}様&body=${encodeURIComponent(mailBody)}`;
    
    // メールクライアントを開く
    window.location.href = mailtoLink;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact-form" className="relative py-16 sm:py-24 lg:py-32 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/ef7c73a22ee1452107c656f146c32c17.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-black/40"></div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <h2 className="text-3xl sm:text-5xl lg:text-7xl font-bold text-white mb-6 sm:mb-8 tracking-wide leading-tight">
          書類作成の負担を減らしたい方へ
        </h2>
        
        <p className="text-xl sm:text-2xl lg:text-3xl text-white mb-2 sm:mb-4 leading-relaxed">
          施工体制台帳・安全書類の作成は
        </p>
        <p className="text-xl sm:text-2xl lg:text-3xl text-white mb-8 sm:mb-12 leading-relaxed">
          専門行政書士にお任せください
        </p>

        {/* Contact Form */}
        <div className="bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-10 shadow-2xl max-w-2xl mx-auto">
          <h3 className="text-2xl sm:text-3xl font-bold text-[#1a2332] mb-4 sm:mb-6">
            無料相談フォーム
          </h3>
          <p className="text-sm sm:text-base text-gray-600 mb-6 sm:mb-8">
            無料相談・初回ヒアリング・お見積りはすべて無料です
          </p>

          <form id="contact-form-element" onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label className="block text-left text-sm font-bold text-[#1a2332] mb-2">
                  お名前 <span className="text-[#ff6b35]">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#ff6b35] focus:outline-none text-sm transition-all"
                  placeholder="山田 太郎"
                />
              </div>
              <div>
                <label className="block text-left text-sm font-bold text-[#1a2332] mb-2">
                  会社名 <span className="text-[#ff6b35]">*</span>
                </label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#ff6b35] focus:outline-none text-sm transition-all"
                  placeholder="株式会社〇〇建設"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label className="block text-left text-sm font-bold text-[#1a2332] mb-2">
                  メールアドレス <span className="text-[#ff6b35]">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#ff6b35] focus:outline-none text-sm transition-all"
                  placeholder="example@company.co.jp"
                />
              </div>
              <div>
                <label className="block text-left text-sm font-bold text-[#1a2332] mb-2">
                  電話番号 <span className="text-[#ff6b35]">*</span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#ff6b35] focus:outline-none text-sm transition-all"
                  placeholder="03-1234-5678"
                />
              </div>
            </div>

            <div>
              <label className="block text-left text-sm font-bold text-[#1a2332] mb-2">
                ご希望のサービス <span className="text-[#ff6b35]">*</span>
              </label>
              <select
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#ff6b35] focus:outline-none text-sm transition-all cursor-pointer"
              >
                <option value="">選択してください</option>
                <option value="施工体制台帳・安全書類作成代行">施工体制台帳・安全書類作成代行</option>
                <option value="電子化サポート">電子化サポート</option>
                <option value="月額サポート">月額サポート</option>
                <option value="その他">その他</option>
              </select>
            </div>

            <div>
              <label className="block text-left text-sm font-bold text-[#1a2332] mb-2">
                お問い合わせ内容
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                maxLength={500}
                rows={5}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#ff6b35] focus:outline-none text-sm transition-all resize-none"
                placeholder="ご相談内容をご記入ください(500文字以内)"
              />
              <div className="text-right text-xs text-gray-500 mt-1">
                {formData.message.length}/500文字
              </div>
            </div>

            <button
              type="submit"
              className="w-full h-14 sm:h-16 bg-[#1a2332] text-white text-base sm:text-lg font-bold rounded-full hover:bg-[#2a3342] transition-all flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
            >
              <div className="w-8 h-8 sm:w-10 sm:h-10 bg-[#ff6b35] rounded-full flex items-center justify-center">
                <i className="ri-send-plane-fill text-white text-lg sm:text-xl"></i>
              </div>
              無料相談する
              <i className="ri-arrow-right-up-line text-lg sm:text-xl"></i>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
